import React from 'react';

class VoucherCodeInput extends React.Component {
  constructor() {
    super();
    this.state = {
      voucherCode: '',
      loading: false
    };
  }

  handleChange = event => {
    let value = event.target.value;
    value = value.toUpperCase();
    this.setState({ voucherCode: value });
  };

  render() {
    return (
      <div className="voucher-code-input">
        <p className="user-instruction">ENTER A VOUCHER CODE</p>
        <input
        id='voucherInput'
          type="text"
          name="voucherCode"
          value={this.state.voucherCode}
          onChange={this.handleChange}
          maxLength={20}
        />
        <button
          className={`btn btn-primary login-button ${this.props.loading ===
            true && 'disabled'}`}
          onClick={() => this.props.handleOfferSelect(this.state.voucherCode, true)}
        >
          {this.props.loading === false ? (
            'Apply Voucher Code'
          ) : (
            <span className="cta-dual-ring"></span>
          )}
        </button>
      </div>
    );
  }
}

export default VoucherCodeInput;
